import React from "react";
import { Box } from "@mui/material";

const STATUS_COLORS = {
  // Numeric account statuses
  1: { label: "Unverified", bg: "#FFFBEB", color: "#B45309" },
  2: { label: "Active", bg: "#ECFDF5", color: "#065F46" },
  3: { label: "Blocked", bg: "#FEF2F2", color: "#B91C1C" },
  4: { label: "Deleted", bg: "#F4F4F5", color: "#71717A" },
  5: { label: "Rejected", bg: "#FEF2F2", color: "#B91C1C" },
  // String statuses
  active: { label: "Active", bg: "#ECFDF5", color: "#065F46" },
  pending: { label: "Pending", bg: "#FFFBEB", color: "#B45309" },
  rejected: { label: "Rejected", bg: "#FEF2F2", color: "#B91C1C" },
  deleted: { label: "Deleted", bg: "#FEF2F2", color: "#B91C1C" },
  inactive: { label: "Inactive", bg: "#F4F4F5", color: "#71717A" },
  blocked: { label: "Blocked", bg: "#FEF2F2", color: "#B91C1C" },
  unverified: { label: "Unverified", bg: "#FFFBEB", color: "#B45309" },
  accepted: { label: "Accepted", bg: "#EFF6FF", color: "#1D4ED8" },
  packed: { label: "Packed", bg: "#F5F3FF", color: "#7C3AED" },
  dispatched: { label: "Dispatched", bg: "#F0FDFA", color: "#0F766E" },
  completed: { label: "Completed", bg: "#ECFDF5", color: "#065F46" },
  declined: { label: "Declined", bg: "#FEF2F2", color: "#B91C1C" },
  cancelled: { label: "Cancelled", bg: "#FEF2F2", color: "#B91C1C" },
  paid: { label: "Paid", bg: "#ECFDF5", color: "#065F46" },
  success: { label: "Success", bg: "#ECFDF5", color: "#065F46" },
  failed: { label: "Failed", bg: "#FEF2F2", color: "#B91C1C" },
  deactivated: { label: "Deactivated", bg: "#F4F4F5", color: "#71717A" },
  sent: { label: "Sent", bg: "#ECFDF5", color: "#065F46" },
  scheduled: { label: "Scheduled", bg: "#EFF6FF", color: "#1D4ED8" },
  // Blog/content statuses
  draft: { label: "Draft", bg: "#F4F4F5", color: "#71717A" },
  published: { label: "Published", bg: "#ECFDF5", color: "#065F46" },
  archived: { label: "Archived", bg: "#F4F4F5", color: "#52525B" },
  approved: { label: "Approved", bg: "#ECFDF5", color: "#065F46" },
  spam: { label: "Spam", bg: "#FFF7ED", color: "#C2410C" },
  // Activity log actions
  created: { label: "Created", bg: "#ECFDF5", color: "#065F46" },
  updated: { label: "Updated", bg: "#EFF6FF", color: "#1D4ED8" },
  restored: { label: "Restored", bg: "#F0FDFA", color: "#0F766E" },
  unpublished: { label: "Unpublished", bg: "#F4F4F5", color: "#71717A" },
  uploaded: { label: "Uploaded", bg: "#EFF6FF", color: "#1D4ED8" },
  reordered: { label: "Reordered", bg: "#F4F4F5", color: "#71717A" },
  upserted: { label: "Upserted", bg: "#EFF6FF", color: "#1D4ED8" },
};

const StatusChip = ({ value }) => {
  const key = typeof value === "number" ? value : (value || "").toLowerCase();
  const entry = STATUS_COLORS[key] || {
    label: String(value || "—"),
    bg: "#F3F4F6",
    color: "#6B7280",
  };
  return (
    <Box
      sx={{
        display: "inline-flex",
        px: 1.5,
        py: 0.4,
        borderRadius: "10px",
        bgcolor: entry.bg,
        fontSize: 12,
        fontWeight: 600,
        color: entry.color,
        fontFamily: "Heebo",
        textTransform: "capitalize",
        whiteSpace: "nowrap",
      }}
    >
      {entry.label}
    </Box>
  );
};

export default StatusChip;
